import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import getters from "./getters";
import VuexPersistence from 'vuex-persist'
import app from './modules/app.js'


Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
          //
      },
      mutations: {
          //
      },
      actions: {
          //
      },
      plugins:[
          new VuexPersistence({
              reducer: state => ({
                  user: state.user, //这个就是存入localStorage的值
                  app:state.app,
                  userInfo:state.userInfo,
              }),
              storage: window.localStorage
          }).plugin
      ],
      modules: {
          app,
      }
  // modules,
  // getters,
  // strict: debug
});